import { TravelstatusMdl } from './TravelBindMdl';
export class TravelPolicyModel
{
    public RegNo: string;
   public PolicyType: string;
   public IqamaNo: string;
   public isProposalEdit: boolean;
   public editObj: TravelProposalEditMdl=new TravelProposalEditMdl();
   public  st: TravelstatusMdl=new TravelstatusMdl();
}
export class TravelProposalEditMdl
{
    public ProposalNo: string;
    public JsonStr: string;
    public ProposalId: string;

}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Models/TravelPolicyModel.ts